<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form :inline="true" :model="formInline" size="mini">
                <el-form-item>
                  <el-button type="default" icon="el-icon-s-fold" @click="collapseHTree"></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-edit" @click="openHoldForm(0)">新增</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="default" icon="el-icon-download" @click="exportList()">导出</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="default" icon="el-icon-delete" @click="deleteHoldInfo(0)">删除</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form :inline="true" size="mini" class="smui-form-right">
                <el-form-item label="用户">
                  <el-input v-model="formInline.hold_name" placeholder="用户名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="formInline.include_children">包含下级数据</el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="loadHoldList()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          
          <div class="sanmuui-body-container">
            <div class="sanmuui-body-left" v-show="displayHTreeVisible">
              <div class="tree-divBox">
                    <el-tree 
                        :data="holdTreeData" 
                        :props="defaultProps" 
                        default-expand-all 
                        ref="getTreeInstance" 
                    @node-click="handleNodeClick"></el-tree>
                </div>
            </div>
            <div class="sanmuui-body-right">
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                @selection-change="handleSelectionChange"
                size="small"
                border
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="hold_name"
                  label="用户名称"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="hold_type"
                  label="用户类型"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="parent_name"
                  label="上级用户"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="login_name"
                  label="管理账号"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="vip_end_time"
                  label="服务到期"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="备注">
                </el-table-column>
                <el-table-column
                  prop="create_time"
                  label="录入时间"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="operator"
                  fixed="right"
                  label="操作"
                  width="250">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="openHoldForm(scope.row.hold_id)">编辑</el-button>
                    <el-button
                      size="mini"
                      @click="ChangeUserPassword(scope.row.user_id, scope.row.login_name)">重置密码</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="deleteHoldInfo(scope.row.hold_id)"
                      v-if="scope.row.hold_id!=1">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div class="dv-pagging-container">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="pagging.pager_size"
                  :pager-count="pagging.pager_count"
                  :total="pagging.records_total"
                  :current-page="pagging.current_page">
                </el-pagination>
              </div>

            </div>
          </div>

      </el-col>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="500px">
        <el-form :model="formNew" :rules="rules" ref="formNew" label-width="80px" class="demo-form-inline" size="medium">
          <el-form-item label="上级用户" :label-width="formLabelWidth" prop="parent">
            <el-input v-model="formNew.parent_hold_name" autocomplete="off" :disabled="true" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="用户名称" :label-width="formLabelWidth" prop="hold_name">
            <el-input v-model="formNew.hold_name" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="账号" :label-width="formLabelWidth" prop="login_name">
            <el-input v-model="formNew.login_name" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="密码" :label-width="formLabelWidth" prop="password" v-if="displayPassword">
            <el-input v-model="formNew.password" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="联系人" :label-width="formLabelWidth" prop="contacts">
            <el-input v-model="formNew.contacts" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="电话" :label-width="formLabelWidth" prop="phone">
            <el-input v-model="formNew.phone" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="服务到期" :label-width="formLabelWidth" prop="vip_end_time">
              <el-date-picker
                v-model="formNew.vip_end_time"
                type="date"
                placeholder="选择日期" style="width: 300px;">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
            <el-input type="textarea" v-model="formNew.remark" class="-form2-input-text"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="addHoldInfo('formNew')" size="small">确 定</el-button>
        </div>
    </el-dialog>

    <!-- 重置账号密码 begin -->
     <el-dialog title="重置账号密码" :visible.sync="dailRepwdVisible" width="500px" :center="true">
        <el-form :model="fmpwd" label-width="100px" class="demo-form-inline" size="medium">
          <el-form-item label="管理账号" :label-width="formLabelWidth">
            <el-input v-model="selectUserName" autocomplete="off" :disabled="true" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="新密码" :label-width="formLabelWidth">
            <el-input v-model="fmpwd.password" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" :label-width="formLabelWidth">
            <el-input v-model="fmpwd.repassword" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dailRepwdVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="SubmitChangePwd()" size="small">确 定</el-button>
        </div>
     </el-dialog>
    <!-- 重置账号密码 end -->

  </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'hold_manage',
  data() {
    return {
      isVisible: false, // 控制浮动层是否显示
      dialogFormVisible: false,
      dailRepwdVisible: false,
      dialogTitle: "新增用户",
      displayHTreeVisible: true,
      formInline: {
        hold_id: null,
        hold_name: '',
        include_children: true,
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      displayPassword: false,
      formLabelWidth: "110px",
      formNew: {
        hold_id: 0,
        parent_hold_id: 0,
        parent_hold_name: "",
        hold_name: "",
        login_name: "",
        password: "",
        contacts: "",
        phone: "",
        vip_end_time: null,
        remark: "",
      },
      rules: {
        hold_name: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        login_name: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        vip_end_time: [
          { required: true, message: '请选择有效期', trigger: 'blur' }
        ]
      },
      tableViewHeight: 600,
      multipleSelection: [],
      loadingTableData: false,
      selectHoldId: 0,
      selectedHoldName: "",
      holdTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      selectUserId: 0,
      selectUserName: '',
      fmpwd: {
        password: '',
        repassword: '',
      }
    }
  },
  methods: {
    openLayer() {
      this.isVisible = true;
    },
    closeLayer() {
      this.isVisible = false;
    },
    handleCurrentChange(val) {
      this.pagging.current_page = val;
      this.loadHoldList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    collapseHTree: function() {
      if(this.displayHTreeVisible) {
        this.displayHTreeVisible = false;
      } else {
        this.displayHTreeVisible = true;
      }
    },
    loadHoldTree: function(){
      Api.GetHoldTree({}).then(res => {
        if(!res)
          return;
        this.holdTreeData = res.data;
        // 初始化选中的用户id
        this.selectHoldId = this.holdTreeData[0].id;
        this.selectedHoldName = this.holdTreeData[0].label;
      });
    },
    refreshPageList: function() {
      this.loadHoldTree();
      this.loadHoldList();
    },
    loadHoldList: function() {
      this.loadingTableData = true;
      this.tableData = [];

      this.formInline.page_index = this.pagging.current_page;
      this.formInline.page_size = this.pagging.pager_size;
      Api.HoldList(this.formInline).then(res => {
        this.loadingTableData = false;
        if(res && res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          this.tableData = res.data;
        } else {
          // this.$message.error(err);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    exportList: function() {
      var argdata = {
        Name: this.formInline.name,
        containChildren: true,
        HoldID: this.selectHoldId
      };
      Api.Hold_ExportList(argdata).then(res => {
          if(!res)
            return;
          if(res.code != 200) {
            this.$message.error(res.msg);
          }
          if(res.data) {
            var hostStr = window.location.host;
            var my_request = hostStr.indexOf('gps881.com') > -1 ?
                `https://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}` :
                `http://${hostStr}/proxyserver/api/file/download_excelfile?fileName=${res.data}`;
            window.open(my_request);
          } else {
            this.$message.error('无数据导出！');
          }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    handleNodeClick: function(data) {
      this.selectHoldId = data.id;
      this.selectedHoldName = data.label;
      this.formInline.hold_id = this.selectHoldId;
      this.closeLayer();
      this.loadHoldList();
    },
    resetFormHoldInfo: function() {
      this.formNew = {
        hold_id: 0,
        parent_hold_id: 0,
        parent_hold_name: "",
        hold_name: "",
        login_name: "",
        password: "",
        contacts: "",
        phone: "",
        vip_end_time: null,
        remark: "",
      };
    },
    openHoldForm: function(id) {
      this.formNew.hold_id = id;
      this.dialogFormVisible = true;
      if(id > 0) {
        this.displayPassword = false;
        this.dialogTitle = "修改用户";
        Api.HoldDetail({ hold_id: id }).then(res => {
          if(res && res.code === 200 && res.data) {
            this.formNew.hold_name = res.data.hold_name;
            this.formNew.login_name = res.data.login_name;
            this.formNew.parent_hold_id = res.data.parent_hold_id;
            this.formNew.parent_hold_name = res.data.parent_hold_name;
            this.formNew.contacts = res.data.contacts;
            this.formNew.phone = res.data.phone;
            this.formNew.vip_end_time = res.data.vip_end_time;
            this.formNew.remark = res.data.remark;
          } else {
            console.log(`获取sim卡资料没返回数据${res ? res.msg : ''}`);
            this.$message.error(`出错了！${res ? res.msg : ''}`);
          }
        });
      } else {
        this.formNew.parent_hold_id = this.selectHoldId;
        this.formNew.parent_hold_name = this.selectedHoldName;
        this.displayPassword = true;
        this.dialogTitle = "新增用户";
      }
    },
    addHoldInfo: function(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Api.AddHold(this.formNew).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '恭喜你，提交成功！',
                type: 'success'
              });
              this.resetFormHoldInfo();
              this.dialogFormVisible = false;
              this.loadHoldTree();
              this.loadHoldList();
            } else {
              this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    deleteHoldInfo: function(id) {
      this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        var masters = [];
        if(id == 0) {
          if(this.multipleSelection.length > 0) {
            this.multipleSelection.forEach(s => {
              masters.push(s.hold_id);
            });
          } else {
            this.$message({
                message: '请选择用户',
                type: 'warning'
            });
            return;
          }
        } else {
          masters.push(id);
        }
         var argdata = {
            hold_ids: masters
          };
          Api.RemoveHold(argdata).then(res => {
            if(!res)
              return;

            if(res.code === 200) {
                this.$message({
                    message: '已删除！',
                    type: 'success'
                });
                this.loadHoldTree();
                this.loadHoldList();
            } else {
                this.$message({
                    message: '删除失败！' + res.msg,
                    type: 'warning'
                });
            }
          });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    // 重置账号密码
    ChangeUserPassword: function(user_id, user_name) {
      this.selectUserId = user_id;
      this.selectUserName = user_name;
      this.dailRepwdVisible = true;
    },
    SubmitChangePwd: function() {
      if(!this.fmpwd.password ||
          !this.fmpwd.repassword) {
            this.$message.error('请输入密码及确认密码!');
            return;
          }
      if(this.fmpwd.password !== this.fmpwd.repassword) {
        this.$message.error('两次输入的密码不一致!');
        return;
      }
      if(this.fmpwd.password.length < 6) {
        this.$message.error('密码长度最少为6个以上字符!');
        return;
      }
      if(!this.selectUserId) {
        this.$message.error('操作异常，请刷新页面重新操作!');
        return;
      }

      var argdata = {
        user_id: this.selectUserId,
        new_password: this.fmpwd.password,
        login_name: this.selectUserName
      };
      Api.ChangeUserPassword(argdata).then(res => {
        if(!res)
          return;

        if(res.code === 200) {
            this.$message({
                message: '密码已重置！',
                type: 'success'
            });
            this.selectUserId = 0;
            this.selectUserName = '';
            this.fmpwd.password = '';
            this.fmpwd.repassword = '';
            this.dailRepwdVisible = false;
        } else {
            this.$message({
                message: '重置失败！' + res.msg,
                type: 'warning'
            });
        }
      });
    }
  },
  mounted() {
    var h = document.body.clientHeight - 220;
    var h2 = document.body.clientHeight - 240;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.loadHoldTree();
    this.loadHoldList();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.smui-form-right {
  float: right;
}
</style>